import { render, staticRenderFns } from "./add-msg-config-model.vue?vue&type=template&id=6a6d80de"
import script from "./add-msg-config-model.vue?vue&type=script&lang=ts"
export * from "./add-msg-config-model.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports